<script>
import BreadCrumb from "@/components/common/BreadCrumb.vue";
import PurchaseHistory from "@/components/acount/PurchaseHistory.vue";
import PurchaseDialog from "@/components/acount/PurchaseDialog.vue";
import astiiss from "@/components/acount/astiiss.vue";
export default {
  components: {
    BreadCrumb,
    PurchaseHistory,
    astiiss,
    PurchaseDialog
  },
  props: {
    id: {},
    urlPage: {},
    urlSearchText: {},
    urlSearchType: {}
  },
  data() {
    let power =
      localStorage.getItem("roles").indexOf("ROLE_COMPLIANCE") > -1
        ? [{ item: "购买历史" }]
        : [{ item: "购买历史" }, { item: "视功能检测" }];
    return {
      breadPath: [
        {
          name: "账户管理",
          target: ""
        },
        {
          name: "账号信息"
        }
      ],
      info: null,
      purchasing: false,
      curId: 0,
      items: power,
      isTak: true,
      isSher: true,
      isShow: false,
      isTak: true,
      number: {},
      number1: {}
    };
  },
  computed: {
    treatments() {
      if (this.info && this.info.treatmentCourses) {
        return this.info.treatmentCourses.filter(function(treatment) {
          return treatment.paymentCompleted;
        });
      }
      return [];
    },
    isNew() {
      return !this.treatments.length;
    },
    totalPrice() {
      let total = 0;
      this.treatments.forEach(treatment => {
        this.number.a = treatment.price;
        this.number.b = treatment.number;
      });
      return this.number.a * this.number.b;
    },
    totalNumber() {
      let total = 0;
      this.treatments.forEach(treatment => {
        total = treatment.price * treatment.number;
      });
      return total;
    }
  },
  created() {
    this.breadPath[0].target = `/index/acountList/${this.urlPage}/${this.urlSearchType}/${this.urlSearchText}`;
    this.reload();
  },
  methods: {
    async reload() {
      this.info = await this.$http.getAcountInfo(this.id);
      localStorage.setItem("id", this.info.id);
    },
    payed() {
      this.purchasing = false;
      this.reload();
    },
    tab(index) {
      this.curId = index;
      if (index === 1) {
        this.isShow = true;
        this.isSher = false;
        this.isTak = false;
      } else {
        this.isShow = false;
        this.isSher = true;
        this.isTak = true;
      }
    }
  }
};
</script>

<template>
  <div class="AcountInfo">
    <PurchaseDialog
      v-if="purchasing"
      @close="purchasing = false"
      :is-new="isNew"
      :patient-id="id"
      @payed="payed"
    />
    <BreadCrumb :path="breadPath" />
    <template v-if="info">
      <div class="content">
        <h1>账号：{{id}}</h1>
        <div class="info">
          <div class="infoLR infoL">
            <p>
              <span class="key" style="width: 70px;">患者姓名：</span>
              <span class="value">{{info.name}}</span>
            </p>
            <p>
              <span class="key" style="width: 70px;">联系人：</span>
              <span class="value">{{info.contact}}</span>
            </p>
            <p v-if="!isNew">
              <span class="key" style="width: 70px;">联系电话：</span>
              <span class="value">{{info.contactPhone}}</span>
            </p>
          </div>
          <div class="infoLR infoR">
            <p>
              <span class="key">创建时间：</span>
              <span class="value">{{moment(info.createdAt, 'YYYY-MM-DD')}}</span>
            </p>
            <template v-if="!isNew">
              <p>
                <span class="key">疗程总计个数：</span>
                <span class="value">{{totalNumber}}个</span>
              </p>
              <p>
                <span class="key">剩余训练次数：</span>
                <span class="value">{{info.trainingCount}}次</span>
              </p>
            </template>
            <p v-else>
              <span class="key" style="width: 70px;">联系电话：</span>
              <span class="value">{{info.contactPhone}}</span>
            </p>
          </div>
          <div class="payArea">
            <Btn @click="purchasing = true">{{isNew?'购买疗程':'疗程续费'}}</Btn>
            <template v-if="!isNew">
              <p class="desc">支付总金额</p>
              <p class="money">￥{{totalPrice | toFixed}}</p>
            </template>
          </div>
        </div>

        <template v-if="treatments.length">
          <div class="tab-bar clearfix">
            <div
              class="tab-bar_div"
              @click="tab(index)"
              v-for="(item,index) in items"
              :key="index"
              v-bind:class="{active : index===curId}"
            >{{item.item}}</div>
          </div>
          <PurchaseHistory v-if="isSher"></PurchaseHistory>
          <astiiss v-if="isShow"></astiiss>
          <table cellspacing="0">
            <tr v-for="treatment in treatments" :key="treatment.id" v-show="isTak">
              <td>{{moment(treatment.createdAt, 'YYYY-MM-DD')}}</td>
              <td>{{treatment.createdBy.name}}</td>
              <td>{{treatment.number}}个</td>
              <td>￥{{treatment.price*treatment.number | toFixed}}</td>
            </tr>
          </table>
        </template>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "@/css/acountInfoContent.scss";
.AcountInfo {
  height: 100%;
  width: 100%;
  overflow: auto;
  .BreadCrumb {
    margin-left: 31px;
    padding-top: 19px;
  }
  .payArea {
    // width:30%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-end;
    .Btn {
      width: 110px;
      height: 37px;
      border-radius: 3px;
      margin-bottom: 13px;
    }
    .desc {
      color: rgba(0, 0, 0, 0.45);
      line-height: 22px;
    }
    .money {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 28px;
    }
  }
  .content {
    margin: 47px 15px 0px 31px;
    h1 {
      padding-left: 26px;
      font-size: 20px;
      font-weight: 100;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 18px;
    }
    .info {
      @extend %acountInfoContent;
    }
    .historyTitle {
      height: 37px;
      line-height: 44px;
      border-radius: 3px 3px 0px 0px;
      border-bottom: 1px solid rgba(233, 233, 233, 1);
      padding-left: 24px;
      margin-top: 24px;
      font-size: 16px;
      color: #4f64ab;
      letter-spacing: 0;
      text-align: left;
      line-height: 24px;
      cursor: pointer;
      user-select: none;
    }
    .tab-bar {
      width: 100%;

      display: flex;
      overflow-y: auto;
    }
    .tab-bar_div {
      margin-top: 20px;
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      text-decoration: none;
      font-size: 16px;
      color: #595959;
      letter-spacing: 0;
      cursor: pointer;
      font-weight: 900;
    }
    .tab-bar .active {
      color: #14a7d7;
      border-bottom: 2px solid #14a7d7;
    }
    .tab-con div {
      text-align: left;
    }
    table {
      width: 100%;
      text-align: left;
      padding: 0px 1px;
    }
    table tr {
      // padding-left: 35px;
      width: 100%;
      display: flex;
    }
    td {
      height: 60px;
      border-bottom: 1px solid #f2f6fb;
      color: #515151;
      flex: 1;
      text-align: center;
      line-height: 60px;
    }
    td:nth-child(1) {
      text-align: left;
      text-indent: 25px;
    }
    td:nth-child(4) {
      text-align: left;
      text-indent: 62px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/acount/AcountInfo.vue